//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Cell from '@/components/cell.vue'
import store from '../store/index'
import { getInfo } from '../api/index'
import wxConfig from '../utils/config'
export default {
  name: 'personalCenter',
  data() {
    return {
      menuList: [
        {
          icon: require('@/assets/icons/money@2x.png'),
          title: '我要捐款',
          to: '/contribute'
        },
        {
          icon: require('@/assets/icons/record@2x.png'),
          title: '捐款记录',
          to: '/records'
        },
        {
          icon: require('@/assets/icons/vip@2x.png'),
          title: '成为会员',
          to: '/vip'
        },
        {
          icon: require('@/assets/icons/edit@2x.png'),
          title: '完善个人信息',
          to: '/edit'
        },
        {
          icon: require('@/assets/icons/mobile@2x.png'),
          title: '更换手机',
          to: '/changeMobile'
        }
      ],
      isShow: false,
      avatar: '',
      name: '',
      tel: '',
      drTotal: 0,
      rank: 0,
      completed: ''
    }
  },
  components: {
    Cell
  },
  methods: {
    logout() {
      this.isShow = false
      // 清理token、用户数据
      store.token = null
      store.userInfo = null
      sessionStorage.clear()
      this.$router.replace('/login')
      //解绑微信
      // location.replace(wxConfig.orginUrl)
    },
    async initInfo() {
      this.$vux.loading.show({
        text: 'Loading...'
      })
      const { data: res } = await getInfo()
      if (res && res.code === 200) {
        const { appUserQueryVo } = res.data
        this.name = appUserQueryVo.username || appUserQueryVo.nickname
        this.tel = appUserQueryVo.phone
        this.avatar = appUserQueryVo.head
        this.drTotal = res.data.donationRankAndTotal.drTotal
        this.rank = res.data.donationRankAndTotal.rank
        store.userInfo = appUserQueryVo
        const infoItems = [
          'username',
          'gender',
          'idcard',
          'nation',
          'dateOfBirth',
          'educationBackground',
          'email',
          'location',
          'locationDetail',
          'profession',
          'company',
          'emergencyPhone'
        ]
        let completedNum = 0
        infoItems.forEach((v) => {
          if (res.data.appUserQueryVo[v] || res.data.appUserQueryVo[v] === 0)
            completedNum++
        })
        this.completed = parseInt((completedNum / infoItems.length) * 100) + '%'
        store.updateInfo = false
      }
      this.$vux.loading.hide()
    }
  },
  activated() {
    document.title = this.$route.meta.title
    if (store.updateInfo) {
      this.initInfo()
    }
  },
  created() {
    document.title = this.$route.meta.title
    // http请求获取用户信息
    this.initInfo()
  }
}



// WEBPACK FOOTER //
// ./src/views/PersonalCenter.vue